/** @format */

import template from './gb-table-item-standard.html';
import './gb-table-item-standard.scss';

export const GbTableItemStandardComponent = {
    template,
    require: {
        gbWidget: '^^',
        gbItemTableWidget: '^^',
        gbTableItem: '^^',
    },
    bindings: {
        item: '<',
        winningBid: '<',
    },
    controller: class GbTableItemStandardComponent {
        constructor($ccColors) {
            'ngInject';

            this.$ccColors = $ccColors;

            this.primaryStyles = {};
            this.accentStyles = {};
        }

        getPrimaryStyles() {
            let bgColor = this.gbWidget.widget.table_primary_color;

            if (bgColor) {
                this.primaryStyles['background-color'] = bgColor;
                this.primaryStyles['color'] = this.$ccColors.getContrast(bgColor);
            }

            return this.primaryStyles;
        }

        getAccentStyles() {
            let bgColor = this.gbWidget.widget.table_accent_color;

            if (bgColor) {
                this.accentStyles['background-color'] = bgColor;
                this.accentStyles['color'] = this.$ccColors.getContrast(bgColor);
            }

            return this.accentStyles;
        }

        getBiddingItem() {
            if (this.item.item_type !== 'bidding') {
                return;
            }

            return this.item.getConcreteItemFromCache();
        }

        getDonationItem() {
            if (this.item.item_type !== 'donation') {
                return;
            }

            return this.item.getConcreteItemFromCache();
        }

        getRaffleItem() {
            if (this.item.item_type !== 'raffle') {
                return;
            }

            return this.item.getConcreteItemFromCache();
        }

        hasBids() {
            return !!this.getBiddingItem() && this.getBiddingItem().winning_bids.length > 0;
        }
    },
};
